module.exports = __webpack_public_path__ + "static/skyline-65135a840d53090f9b35e832317d41fc.png";